var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.$vuetify.breakpoint.name == 'xs'
      ? 'padding-top:50%'
      : _vm.$vuetify.breakpoint.name == 'sm'
      ? 'padding-top:19%'
      : _vm.$vuetify.breakpoint.name == 'md'
      ? 'padding-top:16%'
      : 'padding-top:12%')},[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","align-self-center":"","text-center":""}},[_c('span',{staticClass:"ibmbold xlarge cblack"},[_vm._v(" COMING SOON! ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }